import { render, staticRenderFns } from "./StorageModuleFormGroup.vue?vue&type=template&id=3c58585c&"
import script from "./StorageModuleFormGroup.vue?vue&type=script&lang=ts&"
export * from "./StorageModuleFormGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports